import { fromJS } from 'immutable';
import { mergeEntity, normalizeEntities } from 'helpers/utilHelpers';

import {
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_TYPE_SUCCESS,
  LOAD_DRAWER_EVENTS_SUCCESS,
  LOAD_EVENT_SUCCESS,
  LOAD_EVENT_TYPES_SUCCESS,
  LOAD_EVENTS_SUCCESS,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_TYPE_SUCCESS,
  CLEAR_EVENT_TYPES,
  UPDATE_EVENT_SCHEDULE_SUCCESS,
  LOAD_EVENT_SCHEDULES_SUCCESS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  events: {},
  eventTypes: {},
});

/**
 * Function for prepare event item
 * @param event
 * @param types
 * @return {*}
 */
const prepareEvent = (event, types = null) => {
  const excludingEvent = ['type', 'schedule'];

  if (event.type && types) {
    types.push(event.type);
  }

  excludingEvent.forEach((field) => delete event[field]);

  return event;
};

const eventsReducer = (state = initialState, action) => {
  let types = [];
  switch (action.type) {
    case LOAD_EVENT_SUCCESS: {
      const event = prepareEvent({ ...action.event }, types);
      return state.setIn(['events', event.eventId], mergeEntity(event, state.getIn(['events', event.eventId])));
    }
    case LOAD_DRAWER_EVENTS_SUCCESS: {
      const events = action.events.items.map((event) => prepareEvent({ ...event }, types));
      return state.set('events', normalizeEntities(events, 'eventId', state.get('events')));
    }
    case LOAD_EVENTS_SUCCESS: {
      const events = action.events.items.map((event) => prepareEvent({ ...event }, types));
      return state.set('events', normalizeEntities(events, 'eventId', state.get('events')));
    }
    case LOAD_EVENT_TYPES_SUCCESS:
      return state.set('eventTypes', normalizeEntities(action.eventTypes.items, 'typeId'));
    case CLEAR_EVENT_TYPES: {
      return state.set('eventTypes', initialState.get('eventTypes'));
    }
    case UPDATE_EVENT_SUCCESS: {
      const event = prepareEvent({ ...action.event }, types);
      return state.setIn(['events', event.eventId], mergeEntity(event, state.getIn(['events', event.eventId])));
    }
    case UPDATE_EVENT_TYPE_SUCCESS: {
      const type = { ...action.eventType };
      return state.setIn(['eventTypes', type.typeId], mergeEntity(type, state.getIn(['eventTypes', type.typeId])));
    }
    case LOAD_EVENT_SCHEDULES_SUCCESS: {
      const events = action.schedules.items
        .filter((schedule) => schedule.entityModel)
        .map((schedule) => schedule.entityModel);

      return state.set('events', normalizeEntities(events, 'eventId', state.get('events')));
    }
    case DELETE_EVENT_SUCCESS:
      return state.deleteIn(['events', action.eventId]);
    case DELETE_EVENT_TYPE_SUCCESS:
      return state.deleteIn(['eventTypes', action.typeId]);
    case UPDATE_EVENT_SCHEDULE_SUCCESS: {
      const eventId = action.schedule.entityId;
      if (state.getIn(['events', eventId])) {
        return state.setIn(['events', eventId, 'scheduleId'], action.schedule.scheduleId);
      }
      return state;
    }
    default:
      return state;
  }
};

export default eventsReducer;
